import { customStorage } from './CommonService';

const versions = new Map();
const storageKey = roomId => `pwf-room-membership:${roomId}`;
const credentialKey = roomId => `pwf-room-credential:${roomId}`;
// Per-tab capabilities survive refresh without sharing another tab's room.
export const getRoomCredential = roomId => roomId ? customStorage.session.getItem(credentialKey(roomId)) || '' : '';
export const rememberRoomCredential = (roomId, credential) => {
    if (roomId && credential) customStorage.session.setItem(credentialKey(roomId), credential);
};
export const clearRoomCredentials = () => {
    customStorage.session.keys().filter(key => key.startsWith('pwf-room-credential:'))
        .forEach(key => customStorage.session.removeItem(key));
};
export const rememberRoomMembership = (roomId, version) => {
    if (!roomId || !version) return;
    versions.set(roomId, String(version));
    customStorage.setItem(storageKey(roomId), String(version));
};
export const getRoomMembershipVersion = roomId => {
    if (!versions.has(roomId)) versions.set(roomId, customStorage.getItem(storageKey(roomId)) || '');
    return versions.get(roomId);
};
export const clearRoomMembership = roomId => {
    versions.set(roomId, '');
    customStorage.removeItem(storageKey(roomId));
    customStorage.session.removeItem(credentialKey(roomId));
};
export const roomIdFromRequest = url => /\/api\/(?:action|chat|game\/(?:getroom|leaveroom|autorejoin)|voicechat\/token)\/([^/?]+)/i.exec(url || '')?.[1]
    || /\/api\/profiles\/room\/([^/?]+)/i.exec(url || '')?.[1]
    || /\/api\/rooms\/([^/?]+)\/join-requests\/[^/]+\/decision/i.exec(url || '')?.[1];
